import mlPropertyCoverages from '../config/ml-available-property-coverages.json'

const defaultConfig = {
    coverages: mlPropertyCoverages.coverages
};
const config = Object.assign({}, defaultConfig);

export default {
    getCoverage: (code) => {
        return config.coverages.find((item) => item.code === code);
    }
};